module.exports = __webpack_public_path__ + "static/media/ic_rubber.434abf67.svg";